module.exports = __webpack_public_path__ + "static/img/case.089fb1a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile/case.jpg
// module id = L6ZO
// module chunks = 1